
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M2.78997 14.78L2.69997 14.69C2.30997 14.3 2.30997 13.67 2.69997 13.28L8.78997 7.18003C9.17997 6.79003 9.80997 6.79003 10.2 7.18003L13.49 10.47L19.88 3.29003C20.26 2.86003 20.93 2.85003 21.33 3.25003C21.7 3.63003 21.72 4.23003 21.37 4.62003L14.2 12.69C13.82 13.12 13.16 13.14 12.75 12.73L9.49997 9.48003L4.19997 14.78C3.81997 15.17 3.17997 15.17 2.78997 14.78ZM4.19997 20.78L9.49997 15.48L12.75 18.73C13.16 19.14 13.82 19.12 14.2 18.69L21.37 10.62C21.72 10.23 21.7 9.63003 21.33 9.25003C20.93 8.85003 20.26 8.86003 19.88 9.29003L13.49 16.47L10.2 13.18C9.80997 12.79 9.17997 12.79 8.78997 13.18L2.69997 19.28C2.30997 19.67 2.30997 20.3 2.69997 20.69L2.78997 20.78C3.17997 21.17 3.81997 21.17 4.19997 20.78Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-stacked-line-chart`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconStackedLineChart

    ```js
    <b-new-b-icon-stacked-line-chart />
    ```
</docs>


